import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, Calendar } from 'lucide-react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';

const ApplicationSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10">
        <div className="container-custom py-4 flex justify-between items-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_futbolistas-mentor/artifacts/yf77589j_IMG_1273.png" 
            alt="Agente 360" 
            className="h-12 object-contain cursor-pointer"
            onClick={() => navigate('/')}
          />
          <Button 
            variant="ghost"
            onClick={() => navigate('/')}
            className="text-white hover:text-amber-400"
          >
            Volver al inicio
          </Button>
        </div>
      </header>

      <div className="container-custom pt-32 pb-20 max-w-5xl">
        {/* Success Message */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-500/10 border-2 border-green-500 mb-6">
            <CheckCircle2 className="w-10 h-10 text-green-500" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Tu perfil ha sido recibido
          </h1>
          <p className="text-xl text-gray-400 mb-2">
            Hemos enviado una confirmación a tu email.
          </p>
        </div>

        {/* Calendar Section */}
        <Card className="p-8 bg-neutral-900 border-amber-400/30 mb-8">
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-400/10 border-2 border-amber-400 mb-4">
              <Calendar className="w-8 h-8 text-amber-400" />
            </div>
            <h2 className="text-3xl font-bold text-white mb-2">
              Ahora elige el mejor momento para tu llamada
            </h2>
            <p className="text-gray-400">
              Selecciona el horario que mejor te funcione
            </p>
          </div>

          {/* Calendly Embed */}
          <div className="calendly-embed-container rounded-xl overflow-hidden" style={{ minHeight: '700px' }}>
            <iframe
              src="https://calendly.com/edgarmerino19/30min"
              width="100%"
              height="700"
              frameBorder="0"
              title="Agendar llamada"
              style={{
                border: 'none',
                borderRadius: '8px'
              }}
            />
          </div>
        </Card>

        {/* Additional Info */}
        <div className="grid md:grid-cols-3 gap-6 mt-12">
          <Card className="p-6 bg-neutral-900/50 border-white/10 text-center">
            <h3 className="text-lg font-bold text-white mb-2">📧 Revisa tu email</h3>
            <p className="text-gray-400 text-sm">
              Te hemos enviado un email de confirmación con todos los detalles
            </p>
          </Card>
          <Card className="p-6 bg-neutral-900/50 border-white/10 text-center">
            <h3 className="text-lg font-bold text-white mb-2">📅 Agenda tu llamada</h3>
            <p className="text-gray-400 text-sm">
              Elige el horario que mejor te funcione en el calendario de arriba
            </p>
          </Card>
          <Card className="p-6 bg-neutral-900/50 border-white/10 text-center">
            <h3 className="text-lg font-bold text-white mb-2">🎯 Prepárate</h3>
            <p className="text-gray-400 text-sm">
              Piensa en tus objetivos y qué quieres conseguir en el fútbol
            </p>
          </Card>
        </div>

        {/* CTA to home */}
        <div className="text-center mt-12">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="border-white/10 text-white hover:bg-white/5"
          >
            Volver a la página principal
          </Button>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-12 bg-black border-t border-white/10">
        <div className="container-custom text-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_futbolistas-mentor/artifacts/yf77589j_IMG_1273.png" 
            alt="Agente 360" 
            className="h-16 object-contain mx-auto mb-6"
          />
          <p className="text-gray-400">
            © 2025 Agente 360. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ApplicationSuccess;
